import { Alert, Flex, Form, Radio, Space, Typography } from "antd"
import { useTranslation } from "react-i18next"

import ButtonComponent from "../../Components/Button"
import Icon from "../../Icon"

const { Text } = Typography

function ExternallyConnectPaymentProcessorForm({
  onClose,
  onSubmit,
  businessAccounts,
  businessAccountsFetching,
  error,
  loading,
  paymentProcessorName
}) {
  const { t } = useTranslation()

  const [form] = Form.useForm()

  const onFinish = (value) => {
    const data = { ...value }
    onSubmit(data)
  }
  const handleClose = () => {
    clearFormData()
    onClose()
  }

  function clearFormData() {
    form.resetFields()
  }

  function handleClearError(e, field) {
    form.setFields([
      {
        name: field,
        errors: []
      }
    ])
  }

  function onFocusHandler(e) {
    handleClearError(e, e.target.name)
  }

  const addErrorIcon = (error) => (
    <span>
      <Icon type={"alert_triangle_error"} /> {t(error)}
    </span>
  )

  if (!businessAccounts.length && !businessAccountsFetching) {
    return (
      <div>
        <Text>
          {`Please create a new business account and your ${paymentProcessorName} account will be integrated automatically.`}
        </Text>

        <Flex gap={16} justify="end" style={{ padding: "24px 3px 3px 0" }}>
          <ButtonComponent size="large" htmlType="button" onClick={handleClose}>
            {t("Cancel")}
          </ButtonComponent>

          <ButtonComponent
            type="primary"
            size="large"
            loading={loading}
            className="flex center"
            onClick={onFinish}
          >
            {t("Create account")}
          </ButtonComponent>
        </Flex>
      </div>
    )
  }

  if (!businessAccounts.length && businessAccountsFetching) {
    return null
  }

  return (
    <Form
      className={"with-default-error"}
      onFinish={onFinish}
      validateTrigger="onSubmit"
      layout="vertical"
      form={form}
      requiredMark={true}
    >
      <Form.Item
        label={t("Select business account")}
        name="business_id"
        rules={[{ required: true, message: addErrorIcon("Required fields were not filled.") }]}
        style={{ marginBottom: "16px" }}
      >
        <Radio.Group size="small" name="business_id" onChange={onFocusHandler}>
          <Space direction="vertical">
            {businessAccounts?.map((ba) => (
              <Radio key={ba.id} value={ba.id}>
                {ba.name}
              </Radio>
            ))}
          </Space>
        </Radio.Group>
      </Form.Item>

      {error && (
        <Alert
          type="error"
          message={<Text strong>{t("Payment processor connection failed")}</Text>}
          description={<Text>{error}</Text>}
          showIcon
          icon={<Icon type="alert_triangle_error" />}
          style={{ marginBottom: 16 }}
        />
      )}

      <Flex gap={16} justify="end" style={{ padding: "0 3px 3px 0" }}>
        <ButtonComponent size="large" htmlType="button" onClick={handleClose}>
          {t("Cancel")}
        </ButtonComponent>

        <ButtonComponent
          type="primary"
          size="large"
          htmlType="submit"
          loading={loading}
          className="flex center"
        >
          {t("Connect")}
        </ButtonComponent>
      </Flex>
    </Form>
  )
}

export default ExternallyConnectPaymentProcessorForm
